import { useEffect, useRef } from 'react';
import { referrerInfo, useAnalytics } from '@atlassian/ptc-common';
import { useAppConfig } from '../AppConfigContext';
import recordDwellTime from './dwell-time';
function recordPageVisitOrigin(replace) {
  const url = new URL(window.location.href);
  if (!url || !url.searchParams) {
    return;
  }

  // ref contains a product like confluence, jira etc.
  const ref = url.searchParams.get('ref') || '';
  // src contains a location like appswitcher, peopledrawer etc.
  const src = url.searchParams.get('src') || '';
  if (!ref && !src) {
    return;
  }

  // save referrer info for retrieving it in further screen events
  referrerInfo.set({
    src,
    ref
  });
  url.searchParams.delete('ref');
  url.searchParams.delete('src');

  // replace location if it changed after removing ref and src query params
  if (replace) {
    replace(`${url.pathname}${url.search}`);
  }
}
function RecordTransition(props) {
  const {
    name
  } = props;
  const {
    replace
  } = useAppConfig();
  const refInitialLoadTracked = useRef(false);
  const analytics = useAnalytics();
  useEffect(() => {
    if (!refInitialLoadTracked.current) {
      refInitialLoadTracked.current = true;
      // stores referrer info
      recordPageVisitOrigin(replace);
    } else {
      // cleanup stored referrer info on transition
      referrerInfo.cleanup();
    }
    recordDwellTime(name, analytics);
  }, [analytics, name, replace]);
  return null;
}
export default RecordTransition;